var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 16.8674L12.6672 27.4987C12.6672 27.4987 13.1474 28.4934 13.6616 28.4934C14.1758 28.4934 21.8241 20.5368 21.8241 20.5368L30.3292 4.10938L8.96323 14.1231L8.82617 16.8674Z",
    fill: "#085EB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9197 19.5859L13.1823 27.4222C13.1823 27.4222 12.8737 29.8233 15.2743 27.4222C17.6749 25.0211 19.9727 23.1695 19.9727 23.1695",
    fill: "#0476ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.896 17.2434L0.994966 14.6691C0.994966 14.6691 0.0507039 14.286 0.354756 13.4173C0.417347 13.2381 0.543608 13.0857 0.921312 12.8237C2.67197 11.6035 33.3246 0.586113 33.3246 0.586113C33.3246 0.586113 34.1901 0.294472 34.7005 0.48845C34.8268 0.527539 34.9404 0.599469 35.0298 0.696882C35.1191 0.794295 35.181 0.913693 35.2091 1.04287C35.2642 1.27102 35.2873 1.50575 35.2776 1.74027C35.2752 1.94315 35.2506 2.13119 35.232 2.42607C35.0453 5.43827 29.4585 27.9192 29.4585 27.9192C29.4585 27.9192 29.1242 29.2347 27.9266 29.2798C27.6323 29.2893 27.3391 29.2394 27.0645 29.1332C26.7899 29.027 26.5394 28.8665 26.3281 28.6614C23.978 26.6399 15.8552 21.181 14.0603 19.9804C14.0198 19.9528 13.9857 19.9169 13.9603 19.875C13.9349 19.8331 13.9188 19.7863 13.913 19.7376C13.8879 19.6111 14.0255 19.4543 14.0255 19.4543C14.0255 19.4543 28.1695 6.88218 28.5458 5.56237C28.575 5.46012 28.4649 5.40967 28.317 5.45446C27.3776 5.80006 11.0926 16.0841 9.29529 17.2191C9.16592 17.2583 9.02917 17.2666 8.896 17.2434Z",
    fill: "#0476ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ae345e120668f40a2bd7703b2ce8c5a7.svg";
export { ForwardRef as ReactComponent };